import { types } from 'mobx-state-tree'

const Message = types
  .model('Message', {
    value: types.string,
    type: types.string,
    position: types.string,
    errDialogMessage: types.string,
    errDialogType: types.string,
  })
  .actions((self) => {
    // CHANGED: Block function structure

    // ADDED: Define the actions object to enable inter-action calls (Required fix)
    const actions = {
      setMessage(value: string, type?: string, position?: string) {
        self.value = value.toString()
        self.type = type ?? 'NEGATIVE'
        self.position = position ?? 'BOTTOM'
        // FIXED: Calling resetMessage using 'actions'
        setTimeout(() => actions.resetMessage(), 4000)
      },

      resetMessage() {
        self.value = ''
        self.type = 'NEGATIVE'
        self.position = 'BOTTOM'
      },

      resetErrorDialog() {
        self.errDialogMessage = ''
        self.errDialogType = 'NEGATIVE'
      },

      // 🔥 ADDED & CORRECTED: handleSuccess implementation
      handleSuccess(success: { message: string; code?: string }) {
        // CORRECTED: Calling setMessage using 'actions'
        actions.setMessage(success?.message || 'Operation successful', 'POSITIVE')
      },

      handleError(err: any) {
        if (err?.code === '2369') {
          self.errDialogMessage = err?.message
          self.errDialogType = 'CLOSE_WEBVIEW'
        } else {
          // FIXED: Calling setMessage using 'actions'
          actions.setMessage(err?.message || 'An unknown error occurred')
        }
      },

      showErrDialog(err: any, type: 'CLOSE_WEBVIEW' | 'POSITIVE' | 'NEGATIVE' | 'RESET_TO_DMR_HOME') {
        self.errDialogMessage = err
        self.errDialogType = type
      },
    }

    // CHANGED: Must return the actions object
    return actions
  })
  .views((self) => ({
    getMessage(): any {
      return {
        value: self.value,
        type: self.type,
        position: self.position,
        errDialogMessage: self.errDialogMessage,
        errDialogType: self.errDialogType,
      }
    },
  }))

const MessageData = Message.create({
  value: '',
  type: 'NEGATIVE',
  position: 'BOTTOM',
  errDialogMessage: '',
  errDialogType: 'NEGATIVE',
})

export { Message, MessageData }
